module.exports = __webpack_public_path__ + "img/568.92dd00a7.jpg";